import { render, staticRenderFns } from "./ModificaOperazione.vue?vue&type=template&id=55cbfd70&scoped=true&"
import script from "./ModificaOperazione.vue?vue&type=script&lang=js&"
export * from "./ModificaOperazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cbfd70",
  null
  
)

export default component.exports